import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DynamicFormComponent } from '../../dynamic-form/dynamic-form.component';

const EVENT_FORM_SETTINGS = {
  showNavigationButtons: true,
  navigationButtonsLocation: 'bottom',
  showEmptyFormSubmit: false,
  formDataSource: 'event_form_data',
};

@Component({
  selector: 'app-duna-edit-event',
  standalone: true,
  imports: [DynamicFormComponent],
  templateUrl: './duna-edit-event.component.html',
  styleUrl: './duna-edit-event.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DunaEditEventComponent {
  readonly dynamicInput = {
    bundledSurveyForm: { type: 'text', value: 'edit-event' },
    formReceiveFunction: { type: 'text', value: 'update_event' },
    surveyJSON: { type: 'surveyJSON', value: '{}' },
    settings: { type: 'json', value: EVENT_FORM_SETTINGS },
  };
}
